import React from 'react'

export default function Signup() {
  return (
    <div>Sign up</div>
  )
}
